import { withI18n } from 'panda-i18n';
import { CnCascaderSelect as CnCascaderSelectView } from './cascader-select';
import locale from '@/locale';
import './styles/index.scss';
const CnCascaderSelect = withI18n(CnCascaderSelectView, {
    locale,
    componentName: 'CnCascaderSelect',
    _noHoc: true,
});
export { CnCascaderSelect };
